/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationActionResponse {
    getFixupPrototypeFunction() { return RecommendationActionResponse.fixupPrototype; }

    static newInstance(model: Partial<RecommendationActionResponse>): RecommendationActionResponse {
        let obj = Object.assign(new RecommendationActionResponse(), model);
        RecommendationActionResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationActionResponse>): RecommendationActionResponse {
        if (!model) return null;
        return RecommendationActionResponse.newInstance(<RecommendationActionResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationActionResponse) {
        if (!obj) return;

        models.RecommendationActionResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationActionResponse): boolean {
        Object.setPrototypeOf(obj, RecommendationActionResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * recommendation action name
     */
    name: string;

    /**
     * Terms and conditions for performing the recommended action
     */
    terms_and_conditions: string;

    /**
     * if the action will be performed at the resource level
     */
    resource_level: string;

    /**
     * Type of action will be always template
     */
    action_type: string;

    /**
     * Name of template
     */
    action_resource_name: string;

    /**
     * Description about the action in details
     */
    description: string;

}
